export const SET_MASCHINE = "setMaschine";
export const CLEAR_MASCHINE = "clearMaschine";
export const SET_LAUFENDES_PROGRAMM = "setLaufendesProgramm";
export const SET_WARTENDE_PROGRAMME = "setWartendeProgramme";
export const SET_ABGESCHLOSSENE_PROGRAMME = "setAbgeschlosseneProgramme";
export const SET_VORGAENGE = "setVorgaenge";
